import React from "react";
import AllBatches from "./BatchesModule/AllBatches";

const Batches = () => {
  return (
    <div>
      <AllBatches />
    </div>
  );
};

export default Batches;
